module.exports = __webpack_public_path__ + "media/react/features/overview/suggestions/icons/gofundme-icon-c08726bbe630dad7a955929659b1cdbc.png";